import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchTheme = createAsyncThunk(
    'Theme/fetchTheme',
    async (cmpdetail, { rejectWithValue }) => {

        var requestData = CustomStringify({
            Database: cmpdetail?.Database,
            Password: cmpdetail?.Password,
            Server: cmpdetail?.Server,
            User_ID: cmpdetail?.User_ID,
            Port: cmpdetail?.Port,
        });

        try {
            const result = await POST(`/Setting_Data`, requestData);
            return result?.data?.Sett_ColourTheme ? result?.data?.Sett_ColourTheme : "#5198CD";
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message)
        }
    }
);

const ThemeSlice = createSlice({
    name: 'Theme',
    initialState: {
        primaryThemeColor: "#5198CD",
        status: 'idle',
        error: null,
    },
    reducers: {
        changeTheme: (state, action) => {
            if (action.payload) {
                state.primaryThemeColor = action.payload;
            } else {
                state.primaryThemeColor = "#5198CD";
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTheme.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchTheme.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.primaryThemeColor = action.payload;
            })
            .addCase(fetchTheme.rejected, (state, action) => {
                state.status = 'failed';
                state.result = [];
                state.error = action.payload;
            });
    },
});

export const { changeTheme } = ThemeSlice.actions;

export default ThemeSlice.reducer;

